<template>
  <header id="header" :class="{ 'header-fixed': isFixed }">
    <div class="container d-flex align-items-center justify-content-between">
      <!-- Logo -->
      <div id="logo">
        <router-link :to="{ path: '/', hash: '#home' }">
          <LogoComponent />
        </router-link>
      </div>

      <!-- Hamburger button for mobile -->
      <button
        class="navbar-toggler d-md-none"
        type="button"
        @click="isMobileMenuOpen = !isMobileMenuOpen"
        aria-label="Toggle navigation"
      >
        <font-awesome-icon :icon="isMobileMenuOpen ? 'times' : 'bars'" size="lg" />
      </button>

      <!-- Navigation Menu -->
      <nav
        :class="[
          'nav-menu',
          'list-unstyled',
          'd-flex',
          'mb-0',
          'flex-column flex-md-row',
          { 'd-block position-absolute w-100 mt-2 p-3 nav-menu-mobile': isMobileMenuOpen && isMobileView, 'd-none': !isMobileMenuOpen && isMobileView }
        ]"
      >
        <li :class="{ 'menu-active': activeLink === '#home' }">
          <router-link :to="{ path: '/', hash: '#home' }" @click="setActive('#home')">Home</router-link>
        </li>
        <li :class="{ 'menu-active': activeLink === '#about' }">
          <router-link :to="{ path: '/', hash: '#about' }" @click="setActive('#about')">About</router-link>
        </li>
        <li :class="{ 'menu-active': activeLink === '#services' }">
          <router-link :to="{ path: '/', hash: '#services' }" @click="setActive('#services')">Services</router-link>
        </li>
        <li>
          <a href="https://richardm90.github.io/docs/" target="_blank" rel="noopener">Docs</a>
        </li>
        <li :class="{ 'menu-active': activeLink === '#contact' }">
          <router-link :to="{ path: '/', hash: '#contact' }" @click="setActive('#contact')">Contact Us</router-link>
        </li>
      </nav>
    </div>

  </header>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from "vue";
import LogoComponent from "./Logo.vue";

export default {
  name: "HeaderComponent",
  components: { LogoComponent },

  setup() {
    const activeLink = ref("#home");
    const isFixed = ref(false);
    const showBackToTop = ref(false);
    const isMobileMenuOpen = ref(false);
    const isMobileView = ref(window.innerWidth < 768);

    const setActive = (hash) => {
      activeLink.value = hash;
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      isMobileMenuOpen.value = false; // close menu after click
    };

    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      isFixed.value = scrollTop > 100;
      showBackToTop.value = scrollTop > 100;
    };

    const handleResize = () => {
      isMobileView.value = window.innerWidth < 768;
      if (!isMobileView.value) isMobileMenuOpen.value = false;
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleResize);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    });

    return {
      activeLink,
      isFixed,
      showBackToTop,
      scrollToTop,
      setActive,
      isMobileMenuOpen,
      isMobileView,
    };
  },
};
</script>

<style scoped>
/* Override toggle button for Bootstrap 5 */
.navbar-toggler {
  border: none;
}
</style>